import { loadStripe } from '@stripe/stripe-js';
import { productCatalogPopup } from '../components/popups/ProductCatalogPopup';
import { Env } from '../Env';
import { popPurchaseCustomization } from './popPurchaseCustomization';
export async function popProductCatalog({ buyerNickname, customMessage, createCheckoutSession, }) {
    try {
        const product = await productCatalogPopup.pop();
        const stripePromise = loadStripe(Env.PURCHASE_PUBLISHABLE_KEY, {
            stripeAccount: product.merchantId,
        });
        try {
            return await popPurchaseCustomization({
                buyerNickname,
                customMessage,
                product,
                createCheckoutSession,
                stripePromise,
            });
        }
        catch {
            return popProductCatalog({
                buyerNickname,
                customMessage,
                createCheckoutSession,
            });
        }
    }
    catch { }
}
